function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleDiscover = function SvgGoogleDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.952,
    height: 159.954,
    viewBox: "0 0 119.964 119.966"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m17.486 17.162-7.2 7.3 12.7 12.7 12.8 12.8H0v20h35.786l7.2-7.2 7.3-7.2v-20.1l-12.8-12.8-12.7-12.7z",
    style: {
      fill: "#fbbc01",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.057 27.7-.015 27.76 2.815-2.76c2.777-2.723 2.9-2.7 17.2-2.7h14.5l12.7-12.7 12.8-12.8-7.2-7.2-7.3-7.3-12.7 12.7-12.8 12.8V0h-20z",
    style: {
      fill: "#eb4435",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.09999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.637 52.667c-1.088 1.14-3.027 2.966-3.435 4.117-.38 1.071.734 1.443.734 3.083v4.5l22.709 22.7 22.81 22.8 7.202-7.2 7.303-7.3-12.705-12.7-12.805-12.8h35.514v-20H55.338Z",
    style: {
      fill: "#4886f4",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.10002016
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.872 75.638-19.8 19.812 7.2 7.305 7.3 7.205 12.7-12.708 12.8-12.808v35.522h20V84.444l-10-10.007c-9.2-9.105-9.779-10.287-10.079-14.29l.049-4.686z",
    style: {
      fill: "#38a752",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.10003133
    }
  }));
};
export default SvgGoogleDiscover;